import React from 'react';

import FieldValues from 'components/FieldValues';
import { Grid } from 'semantic-ui-react';
import SummaryBlocksListItem from './components/SummaryBlocksListItem';

export default function SummaryBlocks(): React.ReactElement {
    return (
        <FieldValues
            fieldNames={[
                'sprayEquipmentSetId',
                'sprayEntityIds',
                'sprayApplicationRate'
            ]}
        >
            {({
                sprayEquipmentSetId,
                sprayEntityIds,
                sprayApplicationRate
            }): React.ReactElement => (
                <Grid.Column mobile={16} tablet={8} computer={8}>
                    <SummaryBlocksListItem
                        equipmentSetId={sprayEquipmentSetId}
                        entityIds={sprayEntityIds}
                        applicationRate={sprayApplicationRate}
                    />
                </Grid.Column>
            )}
        </FieldValues>
    );
}
